var _desc, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageStreamlineIconoir({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.5 -0.5 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Language--Streamline-Iconoir",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n      Language Streamline Icon: https://streamlinehq.com\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0163125 11.5c0 5.7899625 4.693725000000001 10.4836875 10.4836875 10.4836875 5.7899625 0 10.4836875 -4.693725000000001 10.4836875 -10.4836875 0 -5.7899625 -4.693725000000001 -10.4836875 -10.4836875 -10.4836875C5.7100375 1.0163125 1.0163125 5.7100375 1.0163125 11.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.548416666666666 1.0679666666666667s3.1450583333333335 4.141725 3.1450583333333335 10.4319375c0 6.2902125 -3.1450583333333335 10.432033333333333 -3.1450583333333335 10.432033333333333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.451583333333334 21.9319375s-3.1450583333333335 -4.141820833333334 -3.1450583333333335 -10.432033333333333S10.451583333333334 1.0679666666666667 10.451583333333334 1.0679666666666667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6764125 15.169266666666667h19.647270833333334",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6764125 7.830733333333335h19.647270833333334",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageStreamlineIconoir);
export default __webpack_public_path__ + "static/media/Language--Streamline-Iconoir.e923ab9bae58fab2cb37cf77bbcb2625.svg";
export { ForwardRef as ReactComponent };